import {NgModule} from '@angular/core';
import {CommonModule, DatePipe, JsonPipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';
import {EffectsModule} from '@ngrx/effects';
import {SurveysListEffect} from './surveys-list/store/surveys-list.effects';
import {UsersListEffect} from './users-list/store/users-list.effects';
import {FuseSharedModule} from '@fuse/shared.module';
import {FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule} from '@fuse/components';
import {FuseWidgetModule} from '@fuse/components/widget/widget.module';
import {MaterialModule} from '@material/material.module';
import {MatLegacyChipsModule as MatChipsModule} from '@angular/material/legacy-chips';
import {
    DxSelectBoxModule,
    DxSliderModule,
    DxTextBoxModule,
    DxTemplateModule,
    DxTagBoxModule,
    DxListModule,
    DxDataGridModule,
    DxNumberBoxModule, DxPopupModule,
} from 'devextreme-angular';
import {SurveysListAdminComponent} from './surveys-list/surveys-list-component-admin.component';
import {TokenLoginComponent} from './token-login/token-login.component';
import {UsersListComponent} from './users-list/users-list.component';
import {LaddaModule} from 'angular2-ladda';
import {UserDetailsComponent} from './users-list/user-details/user-details.component';
import {InbeCommonsModule} from '@app/components/_common/inbe-commons.module';
import {PublicationLinksTabComponent} from './users-list/user-details/contributor/publication-links-tab/publication-links-tab.component';
import {TangoCardsComponent} from './tango-cards/tango-cards.component';
import {Adm1nResolver} from '@app/4dm1n/Admin.resolvers';
import {TangoCardsEffects} from './tango-cards/_store/tango-cards.effects';
import {TranslateModule} from '@ngx-translate/core';
import {SendCardsComponent} from './tango-cards/send-cards/send-cards.component';
import { MainFormComponent } from './users-list/user-details/contributor/main-form/main-form.component';
import { OrganizationsListEffects } from './users-list/store/organizations/organizations-list.effects';
import { SurveysDetailsComponent } from './users-list/user-details/contributor/surveys-details/surveys-details.component';
import { TransactionsTabComponent } from './users-list/user-details/contributor/transactions-tab/transactions-tab.component';
import { ExtProfilsTabComponent } from './users-list/user-details/contributor/ext-profils-tab/ext-profils-tab.component';
import {SplitterModule} from '@syncfusion/ej2-angular-layouts';
import { AddCreditToContributorsComponent } from './users-list/user-details/batchActions/add-credit-to-contributors/add-credit-to-contributors.component';
import { SearchCardsComponent } from './tango-cards/search-cards/search-cards.component';
import {ApplicationPipesModule} from '../../application-pipes/application-pipes.module';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import {SurveysSelectorModule} from '../../@shared/surveys-selector/surveys-selector.module';
import {ExtProfilsSelectorModule} from '../../@shared/ext-profils-selector/ext-profils-selector.module';
import {SurveysListModule} from '../../@shared/_referencesLists/surveys-list/surveys-list.module';
import {LoadingDirectiveModule} from '../../@shared/loading-directive/loading-directive.module';
import {UserCreateComponent} from '@app/4dm1n/users-list/user-create/user-create.component';
import {UrlPlaceholderModule} from '../../@shared/_generalTools/url-placeholder/url-placeholder.module';
import {SurveysListComponent} from '../../@shared/_referencesLists/surveys-list/surveys-list.component';
import {PartialsForSurveysComponent} from '../../@shared/_referencesLists/surveys-list/partials-for-surveys/partials-for-surveys.component';
import {JsonEditorComponent} from '../../@shared/_generalTools/json-editor/json-editor.component';
import {IfDebugModeDirective} from '../../@shared/loading-directive/if-debug-mode.directive';
import {GenericListModule} from '../../@shared/_generalTools/generic-list/generic-list.module';
import {UserClientRolesSelectorComponent} from '@app/4dm1n/users-list/user-create/user-client-roles-selector/user-client-roles-selector.component';
import {MatLegacyRadioModule} from '@angular/material/legacy-radio';

const routes: Routes = [

  {path: 'surveysList', component: SurveysListAdminComponent},

  {path: 'usersList/:userType', component: UsersListComponent, resolve: {data: Adm1nResolver}},
  {path: 'usersList', component: UsersListComponent},

  {path: 'tangoCards', component: TangoCardsComponent, resolve: {data: Adm1nResolver}},
  {path: 'tokenLogin/:token', component: TokenLoginComponent},

];

@NgModule({
    declarations: [
        SurveysListAdminComponent,
        TokenLoginComponent,
        UsersListComponent,
        UserDetailsComponent,
        PublicationLinksTabComponent,
        TangoCardsComponent,
        SendCardsComponent,
        MainFormComponent,
        SurveysDetailsComponent,
        TransactionsTabComponent,
        ExtProfilsTabComponent,
        AddCreditToContributorsComponent,
        SearchCardsComponent,
        UserCreateComponent,
    ],
    exports: [
        UserDetailsComponent,
        SurveysListAdminComponent,
    ],
    providers: [JsonPipe, DatePipe],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),

        FormsModule,
        ReactiveFormsModule,

        // Fuse Stuff
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        FuseWidgetModule,

        // Material
        MaterialModule,
        MatChipsModule,

        // Dev Xtreme
        DxSelectBoxModule,
        DxTextBoxModule,
        DxTemplateModule,
        DxSliderModule,
        DxTagBoxModule,
        DxListModule,
        DxDataGridModule,
        DxNumberBoxModule,

        LaddaModule.forRoot({
            style: 'slide-left',
            // spinnerSize: 40,
            // spinnerColor: 'red',
            // spinnerLines: 12
        }),

        EffectsModule.forFeature([SurveysListEffect, UsersListEffect, TangoCardsEffects, OrganizationsListEffects]),
        InbeCommonsModule,
        TranslateModule,
        SplitterModule,
        ApplicationPipesModule,
        DxPopupModule,
        DialogModule,
        SurveysSelectorModule,
        ExtProfilsSelectorModule,
        SurveysListModule,
        LoadingDirectiveModule,
        UrlPlaceholderModule,
        SurveysListComponent,
        PartialsForSurveysComponent,
        JsonEditorComponent,
        IfDebugModeDirective,
        GenericListModule,
        UserClientRolesSelectorComponent,
        MatLegacyRadioModule,
    ]
})
export class Adm1nModule {
}
